<template>
  <div>
    <CalendarNavigationInputs />
    <CalendarNavigationArrows />
  </div>
</template>

<script>
import CalendarNavigationArrows from '@/components/Calendar/CalendarNavigationArrows'
import CalendarNavigationInputs from '@/components/Calendar/CalendarNavigationInputs'

export default {
  name: 'CalendarNavigation',
  components: { CalendarNavigationArrows, CalendarNavigationInputs }
}
</script>

<style scoped>

</style>
